import { getStorage, ref, getDownloadURL } from "firebase/storage"
import { initializeApp } from "firebase/app"
import firebaseConfig from "../config/firebaseConfig"

import React, { useState, useEffect } from "react"
import Plot from "react-plotly.js"
import axios from "axios"
import _ from "lodash"

import homePlotsUrls from "../data/home.json"
import statePlotsUrls from "../data/states.json"

export default function useGetPlot(section, viewport, usState = null) {
  const firebaseApp = initializeApp(firebaseConfig)
  const storage = getStorage(firebaseApp)

  const [loading, setLoading] = useState(true)
  const [err, setErr] = useState(null)
  const [plots, setPlots] = useState([])

  const handlePlots = async (plotSources) => {
    const promiseList = _.map(plotSources, async (plot) => {
      const gsReference = ref(storage, plot.sizes[viewport])
      const docUrl = await getDownloadURL(gsReference)
      return axios.get(docUrl)
    })
    const res = await Promise.all(promiseList)
    const plotList = _.reduce(
      res,
      (acc, { data }, i) => {
        return [
          ...acc,
          {
            plot: plotSources[i].plot,
            comp: <Plot data={data.data} layout={data.layout} />,
          },
        ]
      },
      []
    )
    setPlots(plotList)
  }

  const usStateData = () =>
    _.find(statePlotsUrls, { abbreviation: _.upperCase(usState) })

  const displayPlot = (plot) => {
    const matchedPlot = _.find(plots, { plot })
    return matchedPlot ? matchedPlot.comp : null
  }

  useEffect(async () => {
    if (_.isEmpty(viewport)) return null
    switch (section) {
      case "homepage":
        await handlePlots(homePlotsUrls)
        return setLoading(false)
      case "state":
        const currentStateConfigData = usStateData()
        console.log(currentStateConfigData.plots)
        await handlePlots(currentStateConfigData.plots)
        return setLoading(false)
      default:
        return null
    }
  }, [viewport])

  return [err, loading, displayPlot, usStateData()]
}
